<template>
	<SuiDataTableRow>
		<SuiDataTableCell :colspan="colspan">
			<div class="task-list-row-phase">
				<h4 class="task-list-row-phase__title">{{ phase.title }}</h4>
				<div
					v-if="phase.startDate || phase.endDate"
					class="task-list-row-phase__date"
				>
					<span v-if="phase.startDate">
						{{ formatDateNoCurrentYear(phase.startDate) }}
					</span>
					<span v-if="phase.startDate && phase.endDate"> - </span>
					<span v-if="phase.endDate">
						{{ formatDateNoCurrentYear(phase.endDate) }}
					</span>
				</div>

				<AppDropdown
					:popover-props="{
						distance: 0,
						placement: 'bottom',
					}"
				>
					<template #trigger>
						<SuiButton
							class="task-list-row-phase__actions-button"
							variant="icon"
							:aria-label="$t('more_options')"
						>
							<SuiIcon name="icon-meatballs-16" />
						</SuiButton>
					</template>

					<TaskListActions
						v-if="project"
						:project="project"
						:project-phase-id="phase.id"
						@open-phases-modal="$emit('open-phases-modal')"
					/>
				</AppDropdown>
			</div>
		</SuiDataTableCell>
	</SuiDataTableRow>
</template>

<script setup lang="ts">
import { useFormatter } from '@/composables';
import {
	type TaskListProjectFragment,
	type TaskListPhaseFragment,
} from '@/generated/graphql';
import {
	SuiDataTableRow,
	SuiDataTableCell,
	SuiButton,
	SuiIcon,
} from '@developers/scoro-ui';
import { AppDropdown } from '@/features/App';
import TaskListActions from '../TaskListActions.vue';

export type TaskListRowPhaseProps = {
	phase: TaskListPhaseFragment;
	colspan: number;
	project?: TaskListProjectFragment;
};

defineProps<TaskListRowPhaseProps>();

defineEmits<{
	(e: 'open-phases-modal'): void;
}>();

const { formatDateNoCurrentYear } = useFormatter();
</script>

<style lang="scss">
.task-list-row-phase {
	display: flex;
	align-items: center;
	gap: 1rem;
	line-height: 1;

	&__title {
		color: $blue-50;
	}

	&__date {
		font-size: 1.625rem;
		color: $neutral-70;
	}

	&__actions-button {
		visibility: hidden;
	}

	&:hover {
		.task-list-row-phase__actions-button {
			visibility: visible;
		}
	}
}
</style>
